import { render, staticRenderFns } from "./formulabar.vue?vue&type=template&id=f9ebbbd6&scoped=true&lang=html&"
import script from "./formulabar.vue?vue&type=script&lang=js&"
export * from "./formulabar.vue?vue&type=script&lang=js&"
import style0 from "./formulabar.vue?vue&type=style&index=0&id=f9ebbbd6&prod&lang=scss&scoped=true&"
import style1 from "./formulabar.vue?vue&type=style&index=1&id=f9ebbbd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ebbbd6",
  null
  
)

export default component.exports